/*
  TextFieldOnBlur.jsx
*/

// Npm.
import React, { useState, useEffect } from 'react';

// Components.
import TextField from './TextField';

/**
 * A wrapper around text field that only calls the callback
 * when the input is blurred, or when Enter is pressed.
 *
 * Useful to edit values when the user appears to be done.
 */
export default function TextFieldOnBlur({ value, onChange, onKeyDown, onBlur, type, ...rest }) {

  value = value || '';

  const [rerender, setRerender] = useState(0);
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value, rerender]);

  function updateValue() {
    if (localValue !== value) {
      if (onChange) {
        onChange(localValue);
      }
      setRerender(n => n + 1);  // In case "value" doesn't actually change.
    }
    // TODO: Fix for when type is number. Input doesn't actually update visibly.
  }

  // Handlers.

  function handleChange(event) {
    setLocalValue(event.target.value);
  }

  function handleBlur(event) {
    updateValue();
    if (onBlur) {
      onBlur(event);  // TODO: Make refresh invalid numbers.
    }
  }

  function handleKeyDown(event) {
    if (event.key === 'Enter') {
      updateValue();
    } else if (
      type === 'number'
      && !event.target.value
      && (event.key === 'ArrowDown' || event.key === 'ArrowUp')
    ) {
      event.preventDefault();
      setLocalValue('0');  // Start incrementing at 0 instead of 1 or -1.
    }
    if (onKeyDown) {
      onKeyDown(event);
    }
  }

  return (
    <TextField
      value={localValue}
      type={type}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      onBlur={handleBlur}
      {...rest}
    />
  );
}
